var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSilhouetteWithBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.5 106C82.4949 106 106 82.4949 106 53.5C106 24.5051 82.4949 1 53.5 1C24.5051 1 1 24.5051 1 53.5C1 82.4949 24.5051 106 53.5 106Z",
    fill: "#273449",
    stroke: "#273449",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.804 62.9119C65.8349 62.9119 75.9915 64.8078 75.9915 72.1303C75.9915 79.4527 65.7698 81.2855 53.804 81.2855C41.773 81.2855 31.6165 79.3866 31.6165 72.0671C31.6165 64.7446 41.8352 62.9119 53.804 62.9119ZM53.804 27.4521C61.9529 27.4521 68.4851 33.7893 68.4851 41.6949C68.4851 49.6005 61.9529 55.9376 53.804 55.9376C45.655 55.9376 39.1228 49.6005 39.1228 41.6949C39.1228 33.7893 45.655 27.4521 53.804 27.4521Z",
    fill: "#616679",
    fillOpacity: 0.59
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilhouetteWithBackground);
export default __webpack_public_path__ + "static/media/silhouette-with-background.89c343aa1bc11aa2e14f099e127a708d.svg";
export { ForwardRef as ReactComponent };